import { createSelector } from '@ngrx/store';

import { coreMappingsFeature } from '../reducers/core-mappings.reducer';

export const {
  selectCoreMappingsState,
  selectBuyers: selectCoreMappingBuyers,
  selectBuyersStatus: selectCoreMappingBuyersStatus,
  selectUploadStatus: selectCoreMappingUploadStatus,
  selectUploadSuccessMessage: selectCoreMappingUploadSuccessMessage,
  selectUploadError: selectCoreMappingUploadError,
  selectDownloadStatus: selectCoreMappingDownloadStatus,
  selectDownloadError: selectCoreMappingDownloadError,
} = coreMappingsFeature;

export const selectCoreMappingIsBuyersLoading = createSelector(
  selectCoreMappingBuyersStatus,
  (status) => status === 'loading',
);

export const selectCoreMappingIsUploadLoading = createSelector(
  selectCoreMappingUploadStatus,
  (status) => status === 'loading',
);

export const selectCoreMappingIsUploadSuccess = createSelector(
  selectCoreMappingUploadStatus,
  (status) => status === 'success',
);

export const selectCoreMappingIsDownloadLoading = createSelector(
  selectCoreMappingDownloadStatus,
  (status) => status === 'loading',
);
